<ng-container *ngIf="taskResponses">
            <div class="card  w-100 shadow-sm mb-4" *ngFor="let taskResponse of taskResponses">
              <div class="card-header">
                <h5 class="card-title mb-0">Response to {{taskResponse?.data?.title || taskResponse?.data?.name ?
                  (taskResponse?.data?.title ? taskResponse?.data?.title : taskResponse?.data?.name) :
                  taskResponse.event}}
                </h5>
              </div>
              <div class="card-body pt-2 pb-3">
                <!-- try and work out the type without searching -->
                <ng-container *ngIf="taskResponse.event == 'formSubmitted'">

                  <table class="data-table data-table-alt table table-hover table-sm">
                    <tr>
                      <th width="50%">Field</th>
                      <th width="50%">Value</th>
                    </tr>
                    <tr *ngFor="
                      let field of taskResponse.data?.formattedData | keyvalue;
                      let fieldIndex = index
                    ">
                      <td style="vertical-align: top;">{{ field.key }}</td>
                      <td *ngIf="getTypeOf(field.value) == 'object'">
                        <!-- it's a likert-->
                        <ul>
                          <li *ngFor="let statement of getFieldValue(field.value)">
                            {{ statement.statement
                            }}<strong>
                              -
                              {{statement.optionLabel}}
                            </strong>
                          </li>
                        </ul>
                      </td>
                      <td *ngIf="getTypeOf(field.value) !== 'object'">
                        {{ field.value }}
                      </td>
                    </tr>
                  </table>
                </ng-container>
                <ng-container *ngIf="taskResponse?.event == 'quizCompleted'">
                  <div *ngFor="let item of taskResponse?.data?.answers">
                    <div class="list-group-item py-2" [innerHTML]="item.data.question | safeHtml"></div>
                    <div>
                      <ul *ngIf="item.data.answers" class="list-group list-group-sm">
                        <li *ngFor="let answer of item.data.answers" class="list-group-item">
                          <i class="bx bx-check" *ngIf="answer.correct"></i>
                          <i class="bx bx-x" *ngIf="!answer.correct"></i>
                          {{ answer.answer }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="mt-2"><strong>Score: {{taskResponse.data.score}}</strong></div>
                </ng-container>
                <ng-container *ngIf="taskResponse?.event == 'pickItems'">

                  <div class="inventory-items mt-1">
                    <div *ngFor="let item of taskResponse.data.items" class="inventory-item item-picked">
                      <img src="{{ item.image }}" alt="{{ item.description }}" *ngIf="item.image" />
                      <div class="item-name">{{ item.name }}</div>
                    </div>
                  </div>

                </ng-container>
              </div>
            </div>
          </ng-container>